export default {"src":"/_next/static/media/download_google.bc319d61.svg","height":76,"width":197,"blurWidth":0,"blurHeight":0};